import AggregableDataModel from '../aggregable/AggregableDataModel';

export default class ImportTradesDataModel extends AggregableDataModel {
}